import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetricCard } from '@components/MetricCard';
import { CommunicationMetrics } from '../types';

interface CommunicationMetricsProps {
  metrics: CommunicationMetrics | null;
}

export const CommunicationMetricsCards: React.FC<CommunicationMetricsProps> = ({ metrics }) => {
  const { t } = useTranslation();
  if (!metrics) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[...Array(4)].map((_, index) => (
          <MetricCard key={index} title={t('common.loading')} value="" loading={true} />
        ))}
      </div>
    );
  }

  const metricCards = [
    {
      title: t('communications.totalTemplates'),
      value: metrics.total_templates.toLocaleString(),
      icon: 'description',
      variant: 'primary' as const,
      trend: t('communications.allTemplates'),
      trendType: 'neutral' as const,
    },
    {
      title: t('communications.activeTemplates'),
      value: metrics.active_templates.toLocaleString(),
      icon: 'check_circle',
      variant: 'success' as const,
      trend: t('communications.inUse'),
      trendType: 'positive' as const,
    },
    {
      title: t('communications.inactiveTemplates'),
      value: metrics.inactive_templates.toLocaleString(),
      icon: 'pause_circle',
      variant: 'default' as const,
      trend: t('communications.notInUse'),
      trendType: 'neutral' as const,
    },
    {
      title: t('communications.totalUsage'),
      value: metrics.total_usage.toLocaleString(),
      icon: 'analytics',
      variant: 'info' as const,
      trend: t('communications.allTime'),
      trendType: 'positive' as const,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metricCards.map((card, index) => (
        <MetricCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          variant={card.variant}
          trend={card.trend}
          trendType={card.trendType}
        />
      ))}
    </div>
  );
};
